export default "__VITE_ASSET__DN9wlIJh__"